import { useState } from "react";
import { updatePassword } from "aws-amplify/auth";
import { toast } from "react-toastify";

export function usePasswordChange() {
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");

  const changePassword = async (): Promise<boolean> => {
    if (!newPassword.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)) {
      toast.error("Password must be at least 8 characters long, including a number and a symbol.");
      return false;
    }

    try {
      await updatePassword({ oldPassword: currentPassword, newPassword });
      toast.success("Password changed successfully");
      setCurrentPassword("");
      setNewPassword("");
      return true;
    } catch (error: any) {
      console.error("Password change error:", error);

      if (error.message.includes("LimitExceededException")) {
        toast.error("Too many password change requests, please try again after some time.");
      } else {
        toast.error(`Password change error: ${error.message || "Unknown error"}`);
      }
      return false;
    }
  };

  return {
    currentPassword,
    newPassword,
    setCurrentPassword,
    setNewPassword,
    changePassword,
  };
}

